// extracted by mini-css-extract-plugin
export default {"icon":"IconLinkList_icon--qcd","iconMargin":"IconLinkList_iconMargin--cM8","xs":"IconLinkList_xs--SkI","m":"IconLinkList_m--oY4"};